import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('zh');

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'zh' ? 'en' : 'zh');
  };

  const content = {
    zh: {
      companyName: '暴裂果实',
      tagline: '打造人和 AI 的终极连接',
      description: '我们专注于构建人与 AI 之间的自然连接，让智能技术真正服务于人的需求。',
      mission: '使命',
      missionText: '以技术为桥梁，让人与AI的协作更加自然、高效。',
      vision: '愿景',
      visionText: '成为人与AI和谐共生的技术平台。',
      values: '价值观',
      valuesText: '创新、协作、开放、责任',
      contact: '联系我们',
      getStarted: '开始体验',
      learnMore: '了解更多',
      heroTitle: '连接',
      heroSubtitle: '人与智能的深度对话',
      features: {
        title: '核心能力',
        ai: '智能理解',
        aiDesc: '深度理解人类意图',
        connect: '自然交互',
        connectDesc: '流畅的人机对话体验',
        future: '持续进化',
        futureDesc: '不断学习与优化'
      }
    },
    en: {
      companyName: 'Boogoo',
      tagline: 'Building the Ultimate Connection Between Humans and AI',
      description: 'We focus on building natural connections between humans and AI, making intelligent technology truly serve human needs.',
      mission: 'Mission',
      missionText: 'Using technology as a bridge to make human-AI collaboration more natural and efficient.',
      vision: 'Vision',
      visionText: 'To become a technology platform for harmonious coexistence between humans and AI.',
      values: 'Values',
      valuesText: 'Innovation, Collaboration, Openness, Responsibility',
      contact: 'Contact Us',
      getStarted: 'Get Started',
      learnMore: 'Learn More',
      heroTitle: 'Connection',
      heroSubtitle: 'Deep Dialogue Between Humans and Intelligence',
      features: {
        title: 'Core Capabilities',
        ai: 'Intelligent Understanding',
        aiDesc: 'Deep understanding of human intent',
        connect: 'Natural Interaction',
        connectDesc: 'Smooth human-machine dialogue experience',
        future: 'Continuous Evolution',
        futureDesc: 'Continuous learning and optimization'
      }
    }
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, content: content[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};
